import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useThunk } from "../hooks/useThunk";
import { getUserProfile } from "../store";
import showToast from "../utils/toastNotifications";
import { clearUser } from "../store";
import { useDispatch } from "react-redux";
import { clearSelectedThreadRoomIdAndThreadId } from "../store";

const isAuthenticated = () => {
    const token = localStorage.getItem("token");
    return !! token;
};

export const ProtectedRoute = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const locations = useLocation();
    /* const[doFetchUserProfile] = useThunk(getUserProfile);

    useEffect(() => {
        
        if(isAuthenticated){
            doFetchUserProfile()
        }

    },[isAuthenticated])*/
    if(!locations.pathname?.startsWith("/thread")){
        dispatch(clearSelectedThreadRoomIdAndThreadId());
    }

    useEffect(() => {
        const handleStorageChange = (e) => {
            console.log("inside the handler")
            if(e.key === "token" && e.newValue === null ){
                dispatch(clearUser());
                showToast("error", "Session Expired. Please login Again")
                navigate('/signin', {replace: true})
            }
        } 
        window.addEventListener("storage", handleStorageChange)
        return () => {
            window.removeEventListener("storage", handleStorageChange)
        }
    },[])

    return isAuthenticated() ? <Outlet /> : <Navigate to="/signin" replace />
};

export const PublicRoute = () => {

    const locations = useLocation();
    const dispatch = useDispatch();

    if(!locations.pathname?.startsWith("/thread")){
        dispatch(clearSelectedThreadRoomIdAndThreadId());
    }

    //return isAuthenticated() ? <Navigate to="/" replace /> : <Outlet />;
    
    /*return isAuthenticated() ? <Navigate to="/" replace /> :*/ return <Outlet />;
};

export const OtpRouteGuard = () => {

    const location = useLocation();
    const otpAvailable= location.state?.otpAvailable;
    return !otpAvailable ? <Navigate to="/" replace/> : <Outlet/>
}